import React, { useState } from "react";
import "../HOC/HOC.css";
import "../Common/Common.css";
import "../EmailVerification/EmailVerification.css";
import { connect } from "react-redux";
import { userLogin } from "../Common/commonConst";
import { apihandler } from "../Common/apicaller";
import {
  emailValidator,
  logOutURL,
  resendmailURL,
  showNotificationMsz,
  updatEmailURL,
} from "../Common/comman";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import TextInput from "../Common/TextInput";
import Button from "../Common/Button";
import "../Candidate/Resume_dialogue/Resume_dialogue.css";
import Loader from "../Common/Loader";

const EmailVerification = (props) => {
  console.log("props", props);
  const [employ, setEmploy] = useState("");
  const [employError, setEmployError] = useState(false);
  const [emailDailog, setEmailDailog] = useState(false);
  const [emailId, setEmailId] = useState("");
  const [emailIdError, setEmailIdError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const candidate_logout = async () => {
    try {
      setIsLoading(true);
      const payload = {
        userId: props.USERLOGIN.user_id,
      };
      const { status } = await apihandler(payload, logOutURL, "post");

      if (status === 1) {
        await props.dispatch({
          type: userLogin,
          value: "",
        });

        props.navigate("/");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("logout ctach error", error);
    }
  };
  const sendLinkHandler = async () => {
    try {
      setIsLoading(true);
      const { status, message } = await apihandler(
        {},
        resendmailURL + props.USERLOGIN.user_id,
        "get"
      );
      if (status === 1) {
        showNotificationMsz(message, "success");
      } else {
        showNotificationMsz(message, "danger");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("resend mail catch error", error);
    }
  };
  const changeEmailIdHandle = () => {
    setEmailDailog(true);
  };
  const updateEmailHandle = async () => {
    try {
      if (!emailValidator(emailId)) {
        setEmailIdError(true);
        return;
      }
      const payload = {
        userId: props.USERLOGIN.user_id,
        userEmail: emailId,
        hostname: window.location.origin,
      };
      setIsLoading(true);
      const { data, status, message } = await apihandler(
        payload,
        updatEmailURL,
        "patch"
      );
      if (status === 1) {
        showNotificationMsz(message, "success", "10000");
        setEmailDailog(false);
        // window.location = "/";
        props.validateUserData();
      } else {
        showNotificationMsz(message, "danger","10000");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("update email catch error", error);
    }
  };
  return (
    <div>
      <div className="emailVerficationMarign">
        <div className="emial_verifaction_Shadow">
          <h1 className="heading_Name"> Please verify your email address</h1>
          <div>
            <div>
              <div className="candidate_header_dailog_flex">
                {" "}
                if not{" "}
                <b>
                  {props.USERLOGIN?.fname} {props.USERLOGIN?.lname} (
                  {props.USERLOGIN?.user_email}
                  )?
                </b>{" "}
                <span
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={candidate_logout}
                >
                  Log Out
                </span>
              </div>
              <div>
                <p>
                  To verify your email address, click on the verification link
                  in the email that you receive from resume-search.com.
                </p>
                <p>You may resend the email by clicking on the button below.</p>
              </div>
              <div className="text-right">
                <Button
                  title="Resend Verification Email"
                  onClick={sendLinkHandler}
                />
              </div>

              <div className="verifction_facing_issue_flex">
                <a href="/get-in-touch"> Facing issue ?</a>
                <p
                  className="verifction_change_emailid"
                  onClick={() => {
                    changeEmailIdHandle();
                  }}
                >
                  Change Email ID
                </p>
              </div>
            </div>
          </div>
          <div className="mr-2 btn_fix_right">
            <Button title="Log Out" onClick={candidate_logout} />
          </div>
          <div>
            <div>
              {/* {chnage_id ? <ChangeEmailDialog open={this.changeEmailId} /> : ""} */}
            </div>
          </div>
        </div>
      </div>

      {/* change email id dailog */}
      <Dialog
        open={emailDailog}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle className="resumeheadline_dailog_title">
          Provide Email
          <span
            className="resume_heaadline_times_button"
            onClick={() => {
              setEmailDailog(false);
            }}
          >
            <i className="fa fa-times " aria-hidden="true"></i>{" "}
          </span>
        </DialogTitle>
        <DialogContent>
          <div>
            <TextInput
              label="New Email Id "
              placeholder="New Email Id "
              value={emailId}
              onChange={(e) => {
                setEmailId(e.target.value);
                setEmailIdError(false);
              }}
            />
            <div>
              {emailIdError && (
                <span className="resumeheadline_error">
                  {" "}
                  Enter a valid email
                </span>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions className="resumeheadline_dailog_action">
          <Button
            title="Update"
            onClick={() => {
              updateEmailHandle();
            }}
          />
        </DialogActions>
      </Dialog>
      <Loader isLoading={isLoading} />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  USERLOGIN: state[userLogin] || "",
});
export default connect(mapStateToProps, null)(EmailVerification);
